import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Box } from "@mantine/core";
import { useLottie } from "lottie-react";
import LogoLottie from "./loader-lottie.json";
const LottieLoader = ({ size = 100, c = "primaryText" }) => {
    const { View } = useLottie({
        animationData: LogoLottie,
        loop: true,
        autoplay: true,
        style: { width: size, height: size },
    });
    return (_jsx(Box, { c: c, sx: {
            ".color-class path": {
                stroke: "currentColor !important",
            },
        }, children: View }));
};
export default LottieLoader;
